import { useCallback, useContext, useState } from 'react';

import { Table } from 'antd';

import {
  ColSize,
  ContentSection,
  RowSize,
} from '../../../../../../../shared/components';
import { PreliquidationStepButtons } from '../../../../shared/components';
import { Summary, TableFilter } from '../';

import { GenericDataFormContext } from '../../../../shared/contexts/GenericDataForm';
import { StepOneFormContext } from '../../contexts/StepOneForm';

import { PreLiquidationStep } from '../../../../shared/interfaces';

import { useSaveQuotas } from './hooks/useSaveQuotas';
import { useTableConfiguration } from './hooks/useTableConfiguration';
import { displayErrorMessage } from '../../../../../../../shared/utils';

import './index.css'

export const QuotasSelector = () => {
  const { setCurrentStep, setCanShowSpinner } = useContext(
    GenericDataFormContext
  );
  const {
    hasSelections,
    preliquidationDataWithFilters,
    totalSelected,
  } = useContext(StepOneFormContext);

  const { columns } = useTableConfiguration();
  const { saveSelectedCells } = useSaveQuotas();

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const handlerOnClick = useCallback(async () => {
    const hasDataToSave = hasSelections();

    try {
      if(Number(totalSelected) <= 0) {
        displayErrorMessage('Debe seleccionar al menos un elemento con un saldo superior a $0.');
        return;
      };
  
      if (hasDataToSave) {
        setCanShowSpinner(true);
        const response = await saveSelectedCells();
        
        if(response){
          setCurrentStep(PreLiquidationStep.TWO);
        }
        setCanShowSpinner(false);
        return;
      };

      displayErrorMessage('Debe seleccionar al menos un elemento de la grilla.');
    } catch (error) {
      setCanShowSpinner(false);
      displayErrorMessage(
        'Una o más celdas no pudieron ser almacenadas, por favor intente otra vez.'
      );
    }
  }, [hasSelections, saveSelectedCells, setCanShowSpinner, setCurrentStep, totalSelected]);

  return (
    <>
      <ContentSection title='Listado de Pólizas' hasCard={false}>
        <RowSize>
          <ColSize size={100}>
            <TableFilter />
          </ColSize>
        </RowSize>
      </ContentSection>
      <ContentSection hasCard={false}>
        <RowSize>
          <ColSize size={100}>
            <Table
              dataSource={preliquidationDataWithFilters}
              columns={columns as any}
              className="preliquidation_compact-table"
              pagination={{
                current: currentPage,
                pageSize: pageSize,
                total: preliquidationDataWithFilters?.length,
                showTotal: (total) =>
                  total === 1 ? 'Una cuota' : `${total} cuotas`,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: (page, pageSize) => {
                  setCurrentPage(page);
                  setPageSize(pageSize);
                },
              }}
              scroll={{ x: 1000 }}
              size="small"
            />
          </ColSize>
        </RowSize>
      </ContentSection>
      <Summary />

      <PreliquidationStepButtons
        label='Continuar'
        onClick={handlerOnClick}
        showGoBack={false}
      />
    </>
  );
};
